define(["../templateFactoryModule", "angular"], function (templateFactoryModule, angular) {
    "use strict";

    return templateFactoryModule.service("templateFactoryMultiBarTemplate", [function () {
        return function (config) {
            var element = angular.element("<div>");
            if (config.context) {
                element.attr("multi-bar-chart", config.context);
            }
            if (config.width) {
                element.attr("size", config.width);
            }
            if (config.height) {
                element.attr("size", config.height);
            }
            if (config.horizontal) {
                element.attr("absolute", config.horizontal);
            }
            return element;
        };
    }]);
});
